import { useEffect } from 'react';

function useEffectOnEveryRender(effect) {
  useEffect(() => {
    effect();
  });
}

function useEffectOnFirstRender(effect) {
  useEffect(() => {
    effect();
  }, []);
}

function useEffectOnFirstAndUpdateRender(effect, inputs) {
  useEffect(() => {
    effect();
  }, inputs);
}

export { useEffectOnEveryRender, useEffectOnFirstRender, useEffectOnFirstAndUpdateRender };



// WEBPACK FOOTER //
// ./src/hooks/useLifeCycles.js